/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import InputText from '@/components/forms/InputText'
import InputSelect from '@/components/forms/InputSelect'
import PeopleInput from '../PeopleInput'
import { ipTypeOptions } from '../../handlers'
import { Flex } from '@chakra-ui/react'
import FormSection from '../../../FormSection'
import { Controller } from 'react-hook-form'
import { useResponsive } from '@/hooks/useResponsive'

const AssetMetadata = ({
  control,
  currentCreators,
  currentPublishers,
  errors,
  fileType,
  register,
  setCreators,
  setPublishers,
  creatorsError,
  publishersError,
  setCreatorsError,
  setPublishersError
}) => {
  const { flexDirection, flexGap } = useResponsive()

  return (
    <FormSection
      title="Asset Metadata"
    >
      <Flex
        flexDirection={flexDirection}
        gap={flexGap}
      >
        <div>
          <InputText
            errorMessage={errors?.title?.message}
            label="Title"
            { ...register('title') }
            />
          <InputSelect
            label="File Type"
            options={fileType}
            disabled={true}
          />
          <PeopleInput
            title="Creators"
            setValues={setCreators}
            initialStrings={currentCreators}
            error={creatorsError}
            setError={setCreatorsError}
          />
        </div>
        <div>
          <Controller
            name="ipType"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <InputSelect
                label="IP Type"
                placeholder="Select a IP Type"
                options={ipTypeOptions}
                errorMessage={error?.message}
                {...field}
              />
            )}
          />
          <InputText
            errorMessage={errors?.uniqueIdentifier?.message}
            label="Unique Identifier"
            { ...register('uniqueIdentifier') }
          />
          <PeopleInput
            title="Publishers"
            setValues={setPublishers}
            initialStrings={currentPublishers}
            error={publishersError}
            setError={setPublishersError}
          />
        </div>
      </Flex>
    </FormSection>
  )
}

export default AssetMetadata
